import React from 'react'

import styles from './Incidents.module.scss';

export default function Incidents() {
  return (
    <div className={`card ${styles.incidents}`}>
        <div className='card-body'>
            <div className={styles.iconWrapper}>
                <span className={`icon-zap ${styles.iconBg}`}></span>
                <span className='icon-three-dots'></span>
            </div>
            <h6 className={styles.title}>Incidents</h6>
            <div className={styles.value}>27</div>
        </div>
    </div>
  )
}
